import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import arrowIosUpwardFill from '@iconify/icons-eva/arrow-ios-upward-fill';
import { Icon } from '@iconify/react';
import { Box, Collapse, List } from '@mui/material';
import { useState } from 'react';
import { matchPath, NavLink as RouterLink, useLocation } from 'react-router-dom';

import { NavItemStyle, NavItemIconStyle } from './styles/NavItemStyles';
import { TestingAttributes } from '../../../constants/testingAttributes/testIdGenerators';
import ListItemTextComponent from '../../generics/ListItemTextComponent/ListItemTextComponent';

export interface INavItemProps {
  title: string;
  path: string;
  icon?: JSX.Element;
  info?: JSX.Element;
  children?: {
    title2: string;
    path2: string;
  }[];
  isVisible?: boolean;
  testAttrs?: TestingAttributes;
}

const NavItem: React.FC<INavItemProps> = (props: INavItemProps) => {
  const { title, path, icon, info, children, isVisible, testAttrs } = props;
  const { pathname } = useLocation();
  const activePath = path ? !!matchPath({ path, end: true }, pathname) : false;
  const [open, setOpen] = useState(activePath);

  const handleOpen = (): void => {
    setOpen(!open);
  };

  return children ? (
    <>
      <NavItemStyle onClick={handleOpen} tabIndex={0}>
        <NavItemIconStyle>{icon}</NavItemIconStyle>
        {isVisible && (
          <>
            <ListItemTextComponent primary={title} />
            {info}
            <Box
              component={Icon}
              icon={open ? arrowIosUpwardFill : arrowIosDownwardFill}
              sx={{ width: 16, height: 16, ml: 1 }}
            />
          </>
        )}
      </NavItemStyle>
      {isVisible && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((item2, index) => {
              const { path2 } = item2;
              const { title2 } = item2;

              return (
                <NavItemStyle
                  {...testAttrs}
                  key={item2.title2.concat(index.toString())}
                  component={RouterLink}
                  to={path2}
                  color="text.primary"
                  tabIndex={0}
                  id={path2}
                >
                  <NavItemIconStyle />
                  <ListItemTextComponent primary={title2} />
                </NavItemStyle>
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  ) : (
    <NavItemStyle {...testAttrs} component={RouterLink} to={path} tabIndex={0} id={path}>
      <NavItemIconStyle>{icon}</NavItemIconStyle>
      {isVisible && (
        <>
          <ListItemTextComponent primary={title} />
          {info}
        </>
      )}
    </NavItemStyle>
  );
};

export default NavItem;
